import React, { useState, useEffect } from 'react';
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { InputField } from '../../../../utility/form/';
import LoadingButton from '../../../../utility/button/LoadingButton';
import useDiscussBox from './useDiscussBox';
import { Pagination } from 'antd';

const DiscussionBox = () => {
  const {
    form,
    errors,
    loading,
    discussions,
    pagination,
    commentInputs,
    handleChange,
    onSubmit,
    addComment,
    setCommentInputs,handlePageChange,handleReaction
  } = useDiscussBox();

  const [openCommentBox, setOpenCommentBox] = useState({}); // toggle per discussion
  const pageSize = pagination.limit;

  const toggleCommentBox = (id) => {
    setOpenCommentBox((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <>
    <div className='without-datepicker-breadcrumb'>
      <Breadcrumb />
      </div>
      <section className="container-fluid discussion-section mt-2"  style={{ minHeight: '100vh' }}>
        <div className="row">
          {/* Left Panel */}
          <div className="col-12 col-lg-4 mb-3 mb-lg-0 px-3 px-md-0">
            <div className="card shadow-sm border-0">
              <div className="card-body h-auto discussionlist">
                <form onSubmit={onSubmit} noValidate>
                  <div className="mb-3">
                    <InputField
                      label="Topic *"
                      name="title"
                      value={form.title}
                      onChange={handleChange}
                      error={errors.title}
                      placeholder="Enter your Topic"
                      type="text"
                    />
                  </div>
                  <div className="mb-3">
                    <InputField
                      label="Description *"
                      name="content"
                      value={form.content}
                      onChange={handleChange}
                      error={errors.content}
                      placeholder="Share your thoughts here…"
                      as="textarea"
                      rows={5}
                    />
                  </div>
                  <div className="text-end">
                    <LoadingButton
                      type="submit"
                      disabled={loading}
                      isLoading={loading}
                      className="btn plan-detail-card-btn rounded-pill px-4"
                    >
                      <i className="bi bi-send me-2"></i>Post
                    </LoadingButton>
                  </div>
                </form>
              </div>
            </div>
          </div>

          {/* Right Panel */}
          <div className="col-12 col-lg-8 d-flex flex-column">
            <div className="px-md-3 pb-3 flex-grow-1">
              <h5 className="fw-bold mb-3">Comments</h5>
              {discussions.length === 0 ? (
                <div className="alert alert-secondary text-center nodatafounddisc">
                  No discussions found.
                </div>
              ) : (
                <div className="d-flex flex-column gap-3" style={{minHeight: "73vh", maxHeight: "73vh", overflow:"scroll"}}>
                  {discussions.map((discussion) => (
                    <div key={discussion.id} className={`card  shadow-sm border-0 ${discussion?.highlighted ? "discussioncard-highlight" : "discussioncard"}`} >
                      <div className="card-body h-auto discussionlist">
                        <h6 className="fw-bold custom-text-dark mb-1">{discussion.title}</h6>
                        <p className="text-muted">{discussion.content}</p>


                        {/* Existing Comments */}
                        {discussion.comments.length > 0 && (
                          <div className="discussion-box p-3 rounded mb-3 overflow-auto" style={{ maxHeight: "150px" }}>
                            <ul className="list-unstyled mb-0">
                              {discussion.comments.map((comment) => (
                                <li key={comment.id} className="d-flex align-items-start mb-2 text-muted small">
                                  <i className="bi bi-chat-dots-fill me-1 text-success me-2"></i>
                                  <span className="text-break">
                                    <strong className="text-dark">
                                      {comment.user?.first_name || "Anonymous"}:
                                    </strong>{' '}
                                    {comment.content}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}

                        {/* Action Buttons */}
                        <div className="d-flex gap-3">
                           {/* Like Button */}
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => handleReaction(discussion.id, 'like')}
                          >
                            <i
                              className={`bi me-1 ${
                               discussion?.currentUserReaction === "like"
                                  ? 'bi-hand-thumbs-up-fill text-primary'
                                  : 'bi-hand-thumbs-up'
                              }`}
                            ></i>{' '}
                            Like ({discussion.reactions?.like || 0})
                          </button>

                          {/* Dislike Button */}
                          <button
                            className="btn btn-light btn-sm"
                            onClick={() => handleReaction(discussion.id, 'dislike')}
                          >
                            <i
                              className={`bi me-1 ${
                                discussion?.currentUserReaction === "dislike"
                                  ? 'bi-hand-thumbs-down-fill text-danger'
                                  : 'bi-hand-thumbs-down'
                              }`}
                            ></i>{' '}
                            Dislike ({discussion.reactions?.dislike || 0})
                          </button>
                          <button className="btn btn-light btn-sm" onClick={() => toggleCommentBox(discussion.id)}>
                            <i className="bi bi-chat-dots-fill me-1 text-success"></i> Comment ({discussion?.comments.length})
                          </button>
                        </div>

                        {/* Comment Input (Toggle Show) */}
                        {openCommentBox[discussion.id] && (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              addComment(discussion.id);
                            }}
                            className="d-flex align-items-center mt-2"
                          >
                            <input
                              type="text"
                              value={commentInputs[discussion.id] || ''}
                              onChange={(e) =>
                                setCommentInputs((prev) => ({
                                  ...prev,
                                  [discussion.id]: e.target.value,
                                }))
                              }
                              className="form-control rounded-pill me-2"
                              placeholder="Write a comment..."
                            />
                            <button
                              type="submit"
                              className="btn btn-outline-primary rounded-circle d-flex align-items-center justify-content-center"
                              style={{ width: '38px', height: '38px' }}
                            >
                              <i className="bi bi-send-fill"></i>
                            </button>
                          </form>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <div className="text-center mt-4 ant-pagination-div">
                <Pagination
                  current={pagination.current_page}
                  pageSize={pagination.limit}
                  total={pagination.total_count}
                  onChange={handlePageChange}
                  showSizeChanger={false}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DiscussionBox;
